
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M10.85 18.85C10.54 18.54 10 18.76 10 19.21V20H6C5.45 20 5 20.45 5 21C5 21.55 5.45 22 6 22H10V22.79C10 23.24 10.54 23.46 10.85 23.14L12.64 21.35C12.84 21.15 12.84 20.84 12.64 20.64L10.85 18.85ZM18 20H15C14.45 20 14 20.45 14 21C14 21.55 14.45 22 15 22H18C18.55 22 19 21.55 19 21C19 20.45 18.55 20 18 20ZM17 0H7C5.9 0 5 0.9 5 2V16C5 17.1 5.9 18 7 18H17C18.1 18 19 17.1 19 16V2C19 0.9 18.1 0 17 0ZM12 6C10.89 6 10 5.1 10 4C10 2.9 10.89 2 11.99 2C13.09 2 13.99 2.9 13.99 4C14 5.1 13.1 6 12 6Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-camera-rear`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconCameraRear

    ```js
    <b-new-b-icon-camera-rear />
    ```
</docs>


